require('./profileSteps.scss');
// @ vendors
const React = require('react');
const { bindActionCreators } = require('redux');
const { connect } = require('react-redux');
import { history } from 'routes/history';
// @ components
const RASetGoalStep1 = require('components/RAComponents/RASetGoal/RASetGoalStep1/RASetGoalStep1');
const RASetGoalStep2 = require('components/RAComponents/RASetGoal/RASetGoalStep2/RASetGoalStep2');
const RoadmapNavigation = require('components/steps/roadmapNavigation').RoadmapNavigation;
const Headline = require('components/headline');
// @ actions
const formActions = require('react-redux-form').actions;
const raSetGoalActions = require('actions/RASetGoal');
const raSuitabilityTestActions = require('actions/RASuitabilityTest');
const raSimulationActions = require('actions/RASimulation');
const raTimeHorizonCheckActions = require('actions/RATimeHorizonCheck');
import { BASE_PATH } from 'constants/index';
const stepsActions = require('actions/stepsActions');
const preLoaderActions = require('actions/preLoaderActions');
// @ utilities
import { FormattedText, formatText } from 'core/i18n';
const UtagHelper = require('utilities/utagHelper');
const { recordPage } = require('utilities/uTagging');
import cryptoJS from 'crypto-js';

// @ constants
const {
    FIRST_STEP,
    SECOND_STEP,
    MINIMUM_OBJECTIVE_INITIAL_INVESTMENT_AMOUNT,
    TIME_HORIZON_CHECK_ERROR,
} = require('constants/RAConstants');
const {
    EVENT_ACTION_OBJECTIVE_CONFIGURATION,
    EVENT_CATEGORY_OBJECTIVE_CONFIGURATION,
} = require('constants/uTagConstants/RAConstants');
const { PATH_GBI_OBJECTIVE_CONFIGURATION } = require('constants/uTagConstants/paths');

class ProfileGbiInvestment extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isClicked: false,
            validDate: true,
        };

        this.handleGoalSetter = this.handleGoalSetter.bind(this);
        this.handleInvestmentDateChange = this.handleInvestmentDateChange.bind(this);
        this.handleInvestmentAmountChange = this.handleInvestmentAmountChange.bind(this);
        this.handleInvestmentTitleChange = this.handleInvestmentTitleChange.bind(this);
        this.onContinue = this.onContinue.bind(this);
        this.sendOkObjectiveSelection = this.sendOkObjectiveSelection.bind(this);
    }

    UNSAFE_componentWillMount() {
        window.scrollTo(0, 0);
    }

    componentDidMount() {
        const {
            userProfile,
            products,
            raSuitabilityTest,
            raSimulationActions,
            immCustomPlanByObjective,
            preLoaderActions,
        } = this.props;
        const docNumberEncrypted = userProfile.docNumber ? cryptoJS.SHA256(userProfile.docNumber).toString() : '';

        raSuitabilityTest.getTestResult();

        if (!immCustomPlanByObjective.get('isFetchedSimulation')) {
            preLoaderActions.showPreLoader();
            raSimulationActions.requestSimulation();
        }

        recordPage(
            PATH_GBI_OBJECTIVE_CONFIGURATION,
            userProfile.recordId,
            userProfile.userId,
            userProfile.product,
            products.get('productsDescription'),
            userProfile.promoCode ? userProfile.promoCode : '',
            false,
            '',
            '',
            userProfile.investmentType,
            {
                identificadorOnboarding: docNumberEncrypted,
            }
        );
    }

    componentDidUpdate(prevProps) {
        const { immCustomPlanByObjective } = this.props;
        const immPrevCustomPlanByObjective = prevProps.immCustomPlanByObjective;

        if (
            immPrevCustomPlanByObjective.get('objectiveEndDate').toString() !==
                immCustomPlanByObjective.get('objectiveEndDate').toString() &&
            immCustomPlanByObjective.get('objectiveType')
        ) {
            this.saveGoal();
        }
    }

    handleGoalSetter(goal) {
        const { raSetGoalActions } = this.props;
        raSetGoalActions.updateGoalSelected(goal);
        this.saveGoal(this.recordObjectiveTag);
    }

    recordObjectiveTag = () => {
        const { userProfile, immCustomPlanByObjective } = this.props;

        const objective = immCustomPlanByObjective.get('objective');
        const endDate = immCustomPlanByObjective.get('objectiveEndDate').toString();
        const tag = `${objective} ${endDate}`;

        UtagHelper.recordEventRoboGBI(
            PATH_GBI_OBJECTIVE_CONFIGURATION,
            EVENT_CATEGORY_OBJECTIVE_CONFIGURATION,
            EVENT_ACTION_OBJECTIVE_CONFIGURATION,
            tag,
            userProfile
        );
    };

    handleInvestmentDateChange(value) {
        const { raSetGoalActions } = this.props;
        raSetGoalActions.setInvestmentGoalValue('investmentDate', value);
    }

    handleInvestmentAmountChange(value) {
        const { raSetGoalActions } = this.props;
        raSetGoalActions.setInvestmentGoalValue('investmentAmount', value);
        this.saveGoal();
    }

    handleInvestmentTitleChange(value) {
        const { raSetGoalActions } = this.props;
        raSetGoalActions.setInvestmentGoalValue('investmentTitle', value);
        this.saveGoal();
    }

    handleChangePicker = value => {
        if (value.current) {
            this.setState({
                validDate: !value.current.state.customInputError,
            });
        }
    };

    handleUpdateAlias = editAlias => {
        editAlias.current.setState({
            aliasEdited: '',
        });
    };

    saveGoal = (callback = null) => {
        const { raSetGoalActions, userProfile, immLoginRobo } = this.props;

        if (!immLoginRobo.get('isLoggedIn')) {
            raSetGoalActions.saveGoalOnboarding(userProfile.accessToken, callback);
        }
    };

    gotoNextStep() {
        const { actions, immStepsState } = this.props;
        const currentIndex = immStepsState.get('currentStep');
        const disabled = this.props.immStepsState.get('readOnlyForms');

        if (!disabled) {
            actions.finalizeStep({
                index: currentIndex,
                finished: true,
            });
            actions.enableFinishedAndNextStep();
            actions.changeCurrentStep({
                index: currentIndex + 1,
            });
        } else {
            actions.changeCurrentStep({
                index: currentIndex + 1,
            });
        }

        this.setState({ isClicked: false });
    }

    onContinue() {
        const { immStepsState, preLoaderActions } = this.props;
        const currentIndex = immStepsState.get('currentStep');
        const currentStep = immStepsState.getIn(['steps', currentIndex]);

        if (currentStep.get('finished')) {
            this.gotoNextStep();
        } else {
            preLoaderActions.showPreLoader();
            this.sendOkObjectiveSelection();
        }
    }

    sendOkObjectiveSelection() {
        const { userProfile, actions, preLoaderActions } = this.props;

        actions.objectivesSelectionOK(userProfile.accessToken, (verifiedOk, errors) => {
            preLoaderActions.hidePreLoader();
            if (verifiedOk) {
                this.gotoNextStep();
            } else {
                if (errors['6002']) {
                    history.push(BASE_PATH + '/errors');
                }
                this.setState({ isClicked: false });
            }
        });
    }

    isStep2Valid() {
        const { immSetGoal, immTimeHorizonCheck } = this.props;
        const immStep = immSetGoal.getIn(['steps', SECOND_STEP]);

        return (
            immStep.get('investmentAmount') >= 500 &&
            immStep.get('investmentTitle') !== '' &&
            !!immStep.get('investmentDate') &&
            immTimeHorizonCheck.get('status') !== TIME_HORIZON_CHECK_ERROR
        );
    }

    render() {
        const { immSetGoal, immCustomPlanByObjective } = this.props;
        const isFirstStepActive = immSetGoal.get('visibleStep') === FIRST_STEP;
        const step2Valid = this.isStep2Valid();
        const immStep = immSetGoal.getIn(['steps', SECOND_STEP]);
        const injectedStrings = [MINIMUM_OBJECTIVE_INITIAL_INVESTMENT_AMOUNT];
        const continueButtonDisabled =
            immCustomPlanByObjective.get('objective') &&
            immCustomPlanByObjective.get('objectiveType') &&
            immCustomPlanByObjective.get('objectiveEndDate') &&
            immCustomPlanByObjective.get('objectiveAmount') &&
            this.state.validDate
                ? false
                : true;

        return (
            <div className="prospects-step-content basic-layering">
                <Headline icon="tarjeta" className="prospects-gutter">
                    <h2>
                        <FormattedText value="profileGbiInvestment-headline" />
                    </h2>
                    <p className="persona-data-view">
                        <FormattedText value="profileGbiInvestment-subtitle" />
                    </p>
                </Headline>
                <div className="persona-data-view">
                    <div className="row profile-gbi-investment__wizard-section">
                        <div className="col-xs-12 profile-gbi-investment__wizard">
                            <RASetGoalStep1
                                active={isFirstStepActive}
                                immSteps={immSetGoal.get('steps')}
                                onGoalSelected={this.handleGoalSetter}
                            />
                            <RASetGoalStep2
                                errorMsg={formatText('raInput-amountInputMinimumValidation', injectedStrings)}
                                errorState={immStep.get('errorFlags')}
                                immSteps={immSetGoal.get('steps')}
                                isValid={step2Valid}
                                onDateChange={this.handleInvestmentDateChange}
                                onInvestmentAmountChange={this.handleInvestmentAmountChange}
                                onTitleChange={this.handleInvestmentTitleChange}
                                onChangePicker={this.handleChangePicker}
                                immCustomPlanByObjective={immCustomPlanByObjective}
                                onUpdateAlias={this.handleUpdateAlias}
                            />
                        </div>
                    </div>
                </div>
                <div className="row form__footer">
                    <div className="col-lg-12">
                        <RoadmapNavigation
                            buttonContinueAction={this.onContinue}
                            buttonContinueDisabled={continueButtonDisabled}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

module.exports.constructor = ProfileGbiInvestment;
module.exports.ProfileGbiInvestment = connect(
    state => ({
        immSetGoal: state.raSetGoal,
        immRaSimulation: state.raSimulation,
        immStepsState: state.steps,
        immTimeHorizonCheck: state.raTimeHorizonCheck,
        userProfile: state.userProfile,
        immCustomPlanByObjective: state.raCustomPlanByObjective,
        products: state.products,
        immLoginRobo: state.loginRobo,
    }),
    dispatch => ({
        actions: bindActionCreators(stepsActions, dispatch),
        formActions: bindActionCreators(formActions, dispatch),
        raSetGoalActions: bindActionCreators(raSetGoalActions, dispatch),
        raSimulationActions: bindActionCreators(raSimulationActions, dispatch),
        raSuitabilityTest: bindActionCreators(raSuitabilityTestActions, dispatch),
        raTimeHorizonCheck: bindActionCreators(raTimeHorizonCheckActions, dispatch),
        preLoaderActions: bindActionCreators(preLoaderActions, dispatch),
    })
)(ProfileGbiInvestment);
